import { z } from 'zod/v4';

export const HI_MEDIA_DEFAULT_TIMEZONE = '+00:00';
// Backend UTC offsets range from -12:00 through +14:00.
export const HI_MEDIA_TIMEZONE_PATTERN =
  '^(?:\\+(?:(?:0\\d|1[0-3]):(?:00|30|45)|14:00)|-(?:(?:0\\d|1[01]):(?:00|30|45)|12:00))$';

/** Canonicalize legacy API values for the editable media path. */
export const normalizeHIMediaTimezone = (
  timezone: string | null | undefined,
) => {
  if (timezone == null) return HI_MEDIA_DEFAULT_TIMEZONE;
  return /^[+-]\d{2}$/.test(timezone) ? `${timezone}:00` : timezone;
};

export const HIMediaPrefixRuleDTO = z.object({
  type: z.enum(['string', 'attribute']),
  string_value: z.string().nullish(),
  attribute_value: z.string().nullish(),
});

export const HIMediaDTO = z.object({
  source: z.enum(['prefix-scan']),
  connector_name: z.string().nullish(),
  config: z.object({
    prefix_rule: HIMediaPrefixRuleDTO,
    path: z.object({
      prefix: z.string().min(1),
      name: z.string().min(1),
      margin_sec: z.number().int().min(0).max(3600).default(120),
      timezone: z.string().nullish(),
    }),
  }),
});
export type HIMedia = z.infer<typeof HIMediaDTO>;

export const HIMediaWriteDTO = HIMediaDTO.extend({
  connector_name: z.string().min(1),
  config: HIMediaDTO.shape.config.extend({
    path: HIMediaDTO.shape.config.shape.path.extend({
      timezone: z
        .string()
        .regex(new RegExp(HI_MEDIA_TIMEZONE_PATTERN))
        .default(HI_MEDIA_DEFAULT_TIMEZONE),
    }),
  }),
});
export type HIMediaWrite = z.infer<typeof HIMediaWriteDTO>;